import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ActionSheetButton, ActionSheetController } from '@ionic/angular';

/**
 * Bouton sélectionné dans l'action sheet
 */
export enum MoreResult {
  /**
   * Clôturer le STI
   */
  CLOSE,
  /**
   * Accéder au détail du STI
   */
  DETAIL,
  /**
   * Supprimer un chrono
   */
  REMOVE_CHRONO,
}

/**
 * Enum sur les origines d'un STI
 */
export enum OrigineSti {
  DAKTECK = 'daktech',
  DACRC = 'dacrc',
  MOBILE = 'mobile',
  CSC = 'csc',
}

/**
 * Classe gérant l'action sheet
 * du STI (clic sur ...)
 */
@Injectable({ providedIn: 'root' })
export class ActionSheetMoreProvider {
  /**
   * Constructeur
   * @param translate
   * @param actionSheetController
   */
  constructor(
    private translate: TranslateService,
    private actionSheetController: ActionSheetController
  ) {}
  /**
   * Ouvre l'action sheet au clic sur les ...
   * qui permet de créer, voir le détail ou clôturer un STI
   * @param {boolean} isStiCreated spécifie si l'OT courant est associé à un STI créé
   * @param {boolean} isSiu spécifie si l'OT courant est un STI avec astreinte
   */
  async openActionSheetMore(
    isStiCreated: boolean,
    canalCreationSti: string,
    isSiu: boolean,
    unplanned: boolean = false,
    isOt = true
  ): Promise<any> {
    const DETAIL_STI_KEY = 'CHRONO.STI.DETAIL';
    const CLOSE_STI_KEY = 'CHRONO.STI.CLOSE';
    const CANCEL_KEY = 'GLOBAL.CANCEL';
    const REMOVE_CHRONO_KEY = 'CHRONO.REMOVE_CHRONO';

    return new Promise((resolve, reject) => {
      const buttons: ActionSheetButton[] = [];
      if (isStiCreated) {
        buttons.push({
          text: this.translate.instant(DETAIL_STI_KEY),
          handler: () => {
            // TODO: Détail STI: si un STI a été créé pour cet OT → US 66
            resolve(MoreResult.DETAIL);
          },
        });
      }
      if (!isSiu && isStiCreated && canalCreationSti != OrigineSti.DACRC) {
        buttons.push({
          text: this.translate.instant(CLOSE_STI_KEY),
          handler: () => {
            // TODO: Clôturer STI: si un STI volontaire (non SIU) a été créé pour cet OT
            // TODO désactiver le STI sur cet OT et envoyer l'information au CRC
            resolve(MoreResult.CLOSE);
          },
        });
      }

      if (canalCreationSti != OrigineSti.DACRC) {
        buttons.push({
          text: this.translate.instant(REMOVE_CHRONO_KEY),
          handler: () => {
            resolve(MoreResult.REMOVE_CHRONO);
          },
        });
      }

      buttons.push({
        text: this.translate.instant(CANCEL_KEY),
        role: 'cancel',
        handler: () => {
          reject('');
        },
      });

      const actionSheet = this.actionSheetController
        .create({
          buttons: buttons,
        })
        .then((a) => a.present());
    });
  }
}
